import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import Toggle from 'material-ui/Toggle';
import Card from 'material-ui/Card';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { getOrgNotificationSubscriptions, setOrgNotificationSubscription } from 'redux/modules/organization';
import { getLikeableLocalTeamMembers, setLLTeamMemberNotification } from 'redux/modules/teamManagement';
import Helmet from 'react-helmet';
import { Spinner, ButtonBar } from 'components';
import * as styles from '../ClientDetail.scss';
var TeamNotificationTab = (_dec = connect(function (state, ownProps) {
  return {
    user: state.auth.user,
    organization: state.organization.current,
    clientDetail: state.teamManagement.clientDetailById && state.teamManagement.clientDetailById[ownProps.clientId] ? state.teamManagement.clientDetailById[ownProps.clientId] : null,
    selectedAssignedTeamMembers: state.teamManagement.selectedAssignedTeamMembers,
    selectedUnassignedTeamMembers: state.teamManagement.selectedUnassignedTeamMembers,
    llTeamMembers: state.teamManagement.llTeamMembers,
    teamMembers: state.teamManagement.teamMembers,
    theme: state.theme
  };
}, {
  setLLTeamMemberNotification: setLLTeamMemberNotification,
  setOrgNotificationSubscription: setOrgNotificationSubscription,
  getOrgNotificationSubscriptions: getOrgNotificationSubscriptions,
  getLikeableLocalTeamMembers: getLikeableLocalTeamMembers
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(TeamNotificationTab, _Component);

  var _super = _createSuper(TeamNotificationTab);

  function TeamNotificationTab(props) {
    var _this;

    _classCallCheck(this, TeamNotificationTab);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateTeamNotificationState", function (UserId, toggled) {
      if (toggled) {
        _this.setState({
          teamNotifications: [].concat(_toConsumableArray(_this.state.teamNotifications), [{
            UserId: UserId
          }])
        });
      } else {
        var idx = _toConsumableArray(_this.state.teamNotifications).findIndex(function (n) {
          return "".concat(n.UserId) === "".concat(UserId);
        });

        if (idx > -1) {
          var a = _toConsumableArray(_this.state.teamNotifications);

          a.splice(idx, 1);

          _this.setState({
            teamNotifications: _toConsumableArray(a)
          });
        }
      }
    });

    _this.state = {
      teamNotifications: [],
      loadingTeamNotifications: false,
      selectedView: 'ACTIVE'
    };
    return _this;
  }

  _createClass(TeamNotificationTab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        loadingTeamNotifications: true
      });
      this.props.getOrgNotificationSubscriptions(this.props.clientId).then(function (_ref) {
        var data = _ref.data;

        _this2.setState({
          teamNotifications: data,
          loadingTeamNotifications: false
        });
      });
      this.props.getLikeableLocalTeamMembers();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return this.state.loadingTeamNotifications ? /*#__PURE__*/React.createElement("div", {
        className: styles.bottomContentWrap
      }, /*#__PURE__*/React.createElement(Spinner, {
        style: {
          position: 'relative'
        },
        center: true
      })) : /*#__PURE__*/React.createElement("div", {
        className: styles.bottomContentWrap,
        style: {
          maxWidth: '50%',
          marginRight: 'auto',
          marginLeft: 'auto'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Team Notifications"
      }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("h1", {
        style: {
          padding: 10
        }
      }, "Team Email Notification Settings"), /*#__PURE__*/React.createElement(Subheader, null, "Email notifications of failures will be sent to the Likeable Local members selected below."), this.state.teamNotifications.length === 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'darkred',
          margin: '24px 56px',
          textAlign: 'center'
        }
      }, "There are no Likeable Local team members assigned to this client. No email notifications will be sent until a member is added."), /*#__PURE__*/React.createElement("div", {
        style: {
          height: 64
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: [{
          title: 'Active Members',
          key: 'ACTIVE',
          selected: this.state.selectedView === 'ACTIVE'
        }, {
          title: 'Inactive Members',
          key: 'INACTIVE',
          selected: this.state.selectedView === 'INACTIVE'
        }],
        onChange: function onChange(val) {
          _this3.setState({
            selectedView: val.key
          });
        }
      })), /*#__PURE__*/React.createElement(List, null, _toConsumableArray(this.props.llTeamMembers).filter(function (t) {
        return t.status === _this3.state.selectedView;
      }).map(function (t, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: "llTeamMember_".concat(t.id),
          primaryText: "".concat(t.firstName, " ").concat(t.lastName),
          rightToggle: /*#__PURE__*/React.createElement(Toggle, {
            defaultToggled: !!_this3.state.teamNotifications.find(function (n) {
              return "".concat(n.UserId) === "".concat(t.id);
            }),
            onToggle: function onToggle(e, toggled) {
              _this3.props.setLLTeamMemberNotification(_this3.props.clientDetail.organization_id, 'failed_posts', toggled, t.id);

              _this3.updateTeamNotificationState(t.id, toggled);
            }
          })
        });
      }))));
    }
  }]);

  return TeamNotificationTab;
}(Component)) || _class);
TeamNotificationTab.defaultProps = {
  assignedTeamMembers: [],
  llTeamMembers: []
};
export default TeamNotificationTab;